import React, { useEffect, useState } from "react";
import Header from "../home/header";
import { useNavigate, useParams } from 'react-router-dom';
import { X } from "lucide-react";
import { ApiClient } from "../../utils/api-client";
import UTILS from "../../utils/commons";
import { AxiosError } from "axios";
import TransactionItem from "./transaction_item";
import Loading from "../home/Loading";
import DocumentPreview from "../home/document_preview";
const TransactionDetail = ( props ) => {
  let navigate = useNavigate();
  var loginState = JSON.parse( window.sessionStorage.getItem( "loginState" ) );
  const apiClient = new ApiClient( loginState ? loginState.accessToken : null );
  var { id } = useParams();

  const [ loading, setLoading ] = useState( true );
  const [ data, setData ] = useState( null );
  const [ recentTransactions, setRecentTransactions ] = useState( [] );

  const getManagerName = ( transaction ) => {
    const manager = transaction?.manager;
    if ( !manager ) return "N/A";

    const managerName = `${manager?.firstName || ''} ${manager?.lastName || ''}`.trim();
    if ( managerName ) return managerName;

    const authName = `${manager?.auth?.firstName || ''} ${manager?.auth?.lastName || ''}`.trim();
    if ( authName ) return authName;

    return manager?.name || manager?.email || "N/A";
  }

  const renderManager = ( transaction ) => {
    const managerName = getManagerName( transaction );
    const managerId = transaction?.manager?.id || transaction?.managerId || transaction?.profileId;

    if ( managerId ) {
      return <span className="hover:underline" onClick={() => navigate(`/staff/view/${managerId}`, { replace: false, state: transaction?.manager })}>{managerName}</span>;
    }

    return managerName;
  }

  const renderSupplier = ( product ) => {
    const supplier = product?.supplier;
    if ( !supplier ) return "N/A";

    const supplierName = supplier?.name || supplier?.supplierName || "N/A";
    if ( supplier?.id ) {
      return <span className="hover:underline" onClick={() => navigate(`/suppliers/view/${supplier.id}`, { replace: false, state: supplier })}>{supplierName}</span>;
    }

    return supplierName;
  }


  const getTransactionDetail = async () => {
    try {
      const req = await apiClient.get( "/transactions/" + id );
      if ( req.status === 200 ) {
        setData( req.data );
      }
      else {
        setData( null );
      }
      return req.data
    }
    catch ( e ) {
      console.log( "Error fetching transaction detail", e );
      setData( null );
      if ( e instanceof AxiosError && e.response && e.response.status === 401 ) {
        UTILS.signout();
        navigate( `/signin`, { replace: true, target: `/transactions/${id}` } );
      }
      return null;
    }
    finally {
      setLoading( false );
    }
  }
  const getRecentTransactions = async ( customerId ) => {
    try {
      const req = await apiClient.get( `/transactions`, {
        params: {
          customerId: customerId,
          limit: 10
        }
      } );
      if ( req.status === 200 ) {
        setRecentTransactions( req.data );
      }
      else {
        setRecentTransactions( [] );
      }
    }
    catch ( e ) {
      console.log( "Error fetching transaction detail", e );
      setData( null );
      if ( e instanceof AxiosError && e.response && e.response.status === 401 ) {
        UTILS.signout();
        navigate( `/signin`, { replace: true, target: `/transactions/${id}` } );
      }
    }
    finally {
      setLoading( false );
    }
  }
  const loadData = async () => {
    const transactionDetail = await getTransactionDetail();
    await getRecentTransactions( transactionDetail?.customer?.id );
  }

  useEffect( () => {
    loadData();
  }, [] )

  return ( <>
    <Header auth={loginState} />
    <section className="container mt-8">
      <div className="w-full mb-4 flex justify-between items-start">
        <div>
          <p className="text-sm uppercase tracking-wide text-gray-500">Sales Record</p>
          <p className="text-2xl font-semibold text-gray-800">Transaction Details</p>
        </div>
        <button className="p-1 rounded-md hover:bg-gray-100 transition-colors" onClick={() => { navigate( '/transactions', { replace: true } ) }}><X className="text-primary-500 hover:text-secondary-500" /></button>
      </div>
      {loading ? <Loading /> : ( data === null ? <div className="text-center py-8">No data to show</div> : null )}
      {data && <>
        <div className="w-full rounded-xl border border-gray-200 bg-gradient-to-r from-white to-gray-50 p-4 md:p-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
            <div className="rounded-lg border border-gray-200 bg-white px-4 py-3">
              <p className="text-xs uppercase tracking-wide text-gray-500">Date</p>
              <p id="date" className="text-secondary-700 font-medium mt-1">{UTILS.formatDate( data?.createdAt )}</p>
            </div>
            <div className="rounded-lg border border-gray-200 bg-white px-4 py-3">
              <p className="text-xs uppercase tracking-wide text-gray-500">Customer</p>
              <p id="customer" className="text-secondary-700 font-medium mt-1"><a className="hover:underline" href={`/customers/view/${data?.customer?.id}`}>{data?.customer?.name || "N/A"}</a></p>
            </div>
            <div className="rounded-lg border border-gray-200 bg-white px-4 py-3">
              <p className="text-xs uppercase tracking-wide text-gray-500">Transaction Type</p>
              <p id="type" className="text-secondary-700 font-medium mt-1">{UTILS.transactionType( data?.type )}</p>
            </div>
            <div className="rounded-lg border border-gray-200 bg-white px-4 py-3">
              <p className="text-xs uppercase tracking-wide text-gray-500">Amount (TZS)</p>
              <p id="amount" className="text-secondary-700 font-semibold mt-1">{data?.totalAmount ? UTILS.thousandSeparator( data?.totalAmount ) : "N/A"}</p>
            </div>
            <div className="rounded-lg border border-gray-200 bg-white px-4 py-3">
              <p className="text-xs uppercase tracking-wide text-gray-500">Handled By</p>
              <p id="manager" className="text-secondary-700 font-medium mt-1">{renderManager( data )}</p>
            </div>
            <div className="rounded-lg border border-gray-200 bg-white px-4 py-3">
              <p className="text-xs uppercase tracking-wide text-gray-500">Document File</p>
              <div className="text-secondary-700 font-medium mt-1">
                <DocumentPreview fileData={data?.file} fileName={`${data?.id || 'transaction'}_document`} />
              </div>
            </div>
          </div>
        </div>

        <div className="text-2xl mt-8 mb-2">Bill Details</div>
        <div className="border border-gray-200 rounded-md overflow-hidden">
          <div className="grid md:grid-cols-5 bg-gray-100 p-3 text-xs uppercase tracking-wide font-semibold text-gray-600">
            <span>SN</span>
            <span>Product</span>
            <span>Quantity</span>
            <span>Unit Price (TZS)</span>
            <span>Amount (TZS)</span>
          </div>

          {data?.transactionProducts?.map( ( item, idx ) => {
            return ( <div key={`${item.transactionId}-${item.productId}`} className={`grid md:grid-cols-5 p-3 border-t border-gray-100 ${idx % 2 === 0 ? "bg-white" : "bg-gray-50"}`}>
              <span>{idx + 1}</span>
              <span>
                {item?.product?.id ? <a className="hover:underline" href={`/products/view/${item.product.id}`}>{item?.product?.productName || "N/A"}</a> : ( item?.product?.productName || "N/A" )}
                {( item?.product?.supplier || item?.product?.supplierId ) && <span className="block text-xs text-gray-500">Supplier: {item?.product?.supplierId && !item?.product?.supplier ? "N/A" : renderSupplier( item?.product )}</span>}
              </span>
              <span>{item.quantity}</span>
              <span>{UTILS.thousandSeparator( item.price )}</span>
              <span className="font-medium">{UTILS.thousandSeparator( item.amount )}</span>
            </div> );
          } )}
          <div className="grid md:grid-cols-5 bg-green-50 p-3 font-bold border-t border-secondary-200">
            <span className="font-bold text-end col-span-4 px-2">Total</span>
            <span className="font-bold text-secondary-700">{UTILS.thousandSeparator( data?.totalAmount )}</span>
          </div>
        </div>

        <div className="text-2xl mt-8 mb-2">Recent Activities</div>
        {recentTransactions.length === 0 ? <div className="mb-2 border border-dashed rounded-md px-3 py-6 text-sm text-gray-500 text-center bg-gray-50">No recent activities</div> :
          <>
            <div className="grid md:grid-cols-6 bg-gray-100 p-3 text-xs uppercase tracking-wide font-semibold text-gray-600 rounded-t-md border border-gray-200">
              <span>Date</span>
              <span>Type</span>
              <span>Customer</span>
              <span>Amount (TZS)</span>
              <span>Document</span>
              <span className="text-start">Action</span>
            </div>
            <div className="border border-t-0 border-gray-200 rounded-b-md overflow-hidden">{recentTransactions.map( ( transaction, idx ) => {
              return <TransactionItem className={`py-1 ${idx % 2 === 0 ? "bg-white" : "bg-gray-100"}`} data={transaction} key={transaction.id} onDelete={() => {}} onClick={() => { navigate( "/transactions/view/" + transaction.id, { replace: false, state: transaction } ) }} onEdit={() => { navigate( "/transactions/edit/" + transaction.id, { replace: false, state: transaction } ) }} />
            } )}</div>
          </>}
      </>}
    </section></>
  )
}
export default TransactionDetail;
